class HolbornPersonalization extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    const { signal } = this.controller;
    const form = this.closest('form');
    const input = this.querySelector('[data-hw-personalization-text]');
    const field = this.querySelector('[data-hw-personalization-field]');
    const error = this.querySelector('[data-hw-personalization-error]');
    const count = this.querySelector('[data-hw-personalization-count]');
    const positions = [...this.querySelectorAll('[data-hw-personalization-position]')];
    const preview = this.querySelector('[data-hw-personalization-preview]');
    const typePreview = this.querySelector('[data-hw-personalization-type-preview]');
    if (!form || !input || !field || !error || !count) return;

    const selected = () => this.querySelector('[data-hw-personalization-choice]:checked')?.value === 'yes';
    const value = () => input.value.normalize('NFC').trim();
    const selectedPosition = () => positions.find(position => position.checked);
    const updatePreview = () => {
      const position = selectedPosition();
      if (preview && position?.dataset.preview) {
        preview.removeAttribute('srcset');
        preview.src = position.dataset.preview;
      }
    };
    const validate = (showError = false) => {
      const text = value();
      if (typePreview) {
        typePreview.textContent = text;
        typePreview.hidden = !text;
      }
      const message = !selected() ? '' : !text ? this.dataset.errorRequired : text.length > 8 ? this.dataset.errorLength : '';
      input.setCustomValidity(message || '');
      count.textContent = `${input.value.length} / 8`;
      if (showError || input.getAttribute('aria-invalid') === 'true') {
        error.textContent = message || '';
        error.hidden = !message;
        if (message) input.setAttribute('aria-invalid', 'true');
        else input.removeAttribute('aria-invalid');
      }
      return !message;
    };
    const sync = () => {
      const enabled = selected();
      field.hidden = !enabled;
      input.disabled = !enabled;
      input.required = enabled;
      positions.forEach(position => { position.disabled = !enabled; });
      updatePreview();
      if (!enabled) {
        input.removeAttribute('aria-invalid');
        error.hidden = true;
        error.textContent = '';
      }
      validate();
    };

    this.querySelectorAll('[data-hw-personalization-choice]').forEach(radio => {
      radio.addEventListener('change', sync, { signal });
    });
    positions.forEach(position => position.addEventListener('change', updatePreview, { signal }));
    input.addEventListener('input', () => validate(), { signal });
    input.addEventListener('blur', () => {
      input.value = value();
      validate();
    }, { signal });
    input.addEventListener('invalid', () => validate(true), { signal });
    form.addEventListener('submit', event => {
      if (selected()) input.value = value();
      if (!validate(true)) {
        event.preventDefault();
        event.stopImmediatePropagation();
        input.reportValidity();
      }
    }, { capture: true, signal });
    form.addEventListener('formdata', event => {
      if (selected() && validate()) event.formData.set(input.name, value());
      else event.formData.delete(input.name);
      const position = selectedPosition();
      if (position) {
        if (selected() && validate()) event.formData.set(position.name, position.value);
        else event.formData.delete(position.name);
      }
    }, { signal });

    sync();
    this.hidden = false;
  }

  disconnectedCallback() {
    this.controller?.abort();
  }
}

if (!customElements.get('hw-holborn-personalization')) {
  customElements.define('hw-holborn-personalization', HolbornPersonalization);
}

